'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _keyMirror2.default)({
  //send email verification
  SEND_EMAIL_VERIFICATION: null,
  SEND_EMAIL_VERIFICATION_SENT: null,
  FAILED_SEND_EMAIL_VERIFICATION: null,

  //complete-verification
  CALL_COMPLETE_VERIFICATION: null,
  SUCCEED_COMPLETE_VERIFICATION: null,
  FAILED_COMPLETE_VERIFICATION: null,

  SUCCEED_GET_EMAIL_VERIFICATION: null,
  FAILED_GET_EMAIL_VERIFICATION: null,
  REQUEST_EMAIL_VERIFICATION: null
});
module.exports = exports['default'];